var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCleverIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 27,
  height: 26,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.612 7.178C22.584 3.452 18.527 1 13.702 1 6.956 1 1.498 6.357 1.498 12.994S6.955 24.988 13.703 25c4.824 0 8.88-2.452 10.909-6.178l-4.192-2.29c-1.395 2.386-3.657 3.89-6.717 3.89-4.124 0-7.35-3.364-7.35-7.422s3.226-7.422 7.35-7.422c3.06 0 5.322 1.503 6.717 3.89l4.192-2.29Z",
  fill: "#fff"
})));
export default SvgCleverIcon;